import React from 'react';

interface CardLayoutProps {
  children: React.ReactNode;
  isFlipped: boolean;
  className?: string;
}

export function CardLayout({ children, isFlipped, className = '' }: CardLayoutProps) {
  return (
    <div className={`
      absolute w-full h-full bg-white rounded-xl 
      border border-gray-100
      ${isFlipped ? 'opacity-0' : 'opacity-100'} 
      transition-all duration-300 ease-in-out preserve-3d backface-hidden
      ${className}
    `}>
      {children}
    </div>
  );
}